import { render, staticRenderFns } from "./CAgreeGroup.vue?vue&type=template&id=1b84a788&"
import script from "./CAgreeGroup.vue?vue&type=script&lang=js&"
export * from "./CAgreeGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports